import { Record as record } from 'immutable';

import validation from '../../validation';
import ValidationMixin from '../ValidationMixin';

class ForgotPasswordForm extends record({ email: null}) {

    static fromJSON(json = {}) {
        return new ForgotPasswordForm(json);
    }

    getSchema () {
        return {
            email: validation.email()
        };
    }
}


Object.assign(ForgotPasswordForm.prototype, ValidationMixin);


export default ForgotPasswordForm;
